import { Helpers } from '../../../../../utility/helpers';
import type { RecipeCartState } from '../../../../recipe/hooks/useRecipeCart';
import type { PriceType } from '../../../models/priceData/priceData';

const getAriaLabelText = (cart: RecipeCartState, priceType: PriceType) => {
    const price = Helpers.getPrice(cart.totalPriceData, priceType);
    let priceText = '';

    if (price) {
        priceText = Helpers.toEcommercePriceWithCurrencyAriaLabel(price);
    }

    return priceText;
};

export const getRecipeCartAnnounceText = (cart: RecipeCartState, priceType: PriceType) => {
    return `Totalt har du ${cart.items.reduce((acc, item) => acc + (item.quantity || 0), 0)} varor för ${getAriaLabelText(cart, priceType)} som du kan lägga till i varukorgen`;
};
